import _Set from "@babel/runtime-corejs3/core-js/set";
import { useInstance, onBeforeUnmount } from 'intact-vue';
import { scrollbarWidth } from '../position';
import { SHOW } from './constants';
var dialogs = new _Set();
var originalStyle = null;
var hooks = null;
export function useFixBody(elementRef) {
  var instance = useInstance();
  var fixedBody = false;
  instance.on(SHOW, onEnter);
  instance.on('afterClose', onAfterLeave);
  onBeforeUnmount(function () {
    // should also remove body style when dialog is removed, #805
    // if (fixedBody && instance.get('value')) {
    if (fixedBody) {
      // maybe HIDE event has not triggered
      onClosed(instance);
    }
  });
  function onEnter() {
    if (instance.get('overlay')) {
      fixedBody = true;
      onOpen(instance);
    }
  }
  function onAfterLeave() {
    if (fixedBody) {
      fixedBody = false;
      onClosed(instance);
    }
  }
}
export function setHooks(h) {
  hooks = h;
}
function onOpen(dialog) {
  var body = document.body;
  if (dialogs.size === 0) {
    var bodyStyle = body.style;
    originalStyle = body.getAttribute('style');
    bodyStyle.overflow = 'hidden';
    var scrollBarWidth = shouldFixBody();
    if (scrollBarWidth) {
      bodyStyle.paddingRight = scrollBarWidth + "px";
    }
    if (hooks && hooks.onStart) {
      hooks.onStart(scrollBarWidth);
    }
  }
  dialogs.add(dialog);
}
function onClosed(dialog) {
  var body = document.body;
  dialogs.delete(dialog);
  if (dialogs.size === 0) {
    if (originalStyle) {
      // console.log(originalStyle);
      body.setAttribute('style', originalStyle);
    } else {
      body.removeAttribute('style');
    }
    if (hooks && hooks.onEnd) {
      hooks.onEnd();
    }
  }
}
function shouldFixBody() {
  if (document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight)) {
    return scrollbarWidth();
  }
}